import React from 'react';
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Registration.css";
const Registration = () => {
  return (
    <>
    <div className="d-flex justify-content-center align-items-center vh-100 bg-gradient">
      <div className="cards p-4 shadow-lg rounded-4" style={{ width: "500px" }}>
        <div className="text-center">
          <h2 className="Register">Register</h2>
          <p className="text-muted">Create your account</p>
        </div>

        <form className="p-2" >
          <div className="mb-3">
            <label className="form-label fw-semibold"> Name</label>
            <input type="text" name="given_name" className="form-control" placeholder="" required />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Email</label>
            <input type="email" name="email_address" className="form-control" placeholder="" required  />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Phone Number</label>
            <input type="text" name="phone_number" className="form-control" placeholder="" required  />
          </div>

          <div className="d-grid">
            <button type="submit" className="btn btn-primary fw-bold">Register</button>
          </div>
        </form>

        <div className="text-center mt-3">
          <p className="text-muted">
            Already have an account? <Link to="/Login" className="text-primary">Login</Link>
          </p>
        </div>

      </div>
    </div>

    
    </>
  )
}
export default Registration;